<template lang="pug">
pr-wrapper.channel-item.border-bottom(:bg="background ? 'overlayTo' : 'transparent'", v-visible="data", :class="{ background }")
  .d-flex.align-items-center.overflow-hidden.pr-3.flex-grow-1
    .placement.d-flex.align-items-center
      i.fal.fa-chevron-left.mx-3(v-visible="!single && background")
      .number.d-flex.flex-column.align-items-center
        i.fal.fa-chevron-up.mb-2(v-visible="background")
        .placement(:class="{ 'text-muted': !background }") {{ data_.placement }}
        i.fal.fa-chevron-down.mt-2(v-visible="background")
    .locked-channel.surface-bg-darker.mx-3.border(v-show="data_.price && !data_.owned")
      i.fas.fa-lock
    imagec.mx-3(
      v-show="!data_.price || data_.owned",
      vertical,
      :src="data_.logo",
      :background="false",
      fallback="/v2/assets/images/def_channel_logo.png"
    )
    .title.overflow-hidden
      pr-text(weight="bold", ellipsis) {{ data_.title }}
      channelProgram.flex-grow-1(:current="data_", v-if="isEpgActive", :muted="background ? false : true")
</template>

<script>
import channelProgram from "./channel-program.vue"
export default {
  name: "channel-item",
  components: { channelProgram },
  props: ["data", "background", "single"],
  computed: {
    data_() {
      return this.data || {}
    },
    isEpgActive() {
      return __.device.config("catchup.epg")
    }
  }
}
</script>

<style lang="scss" scoped>
.channel-item {
  display: flex;
  align-items: center;
  overflow: hidden;

  &:last-child {
    border-bottom: 0 !important;
  }

  .imagec {
    height: 60px;
  }
  .title {
    flex-grow: 1;
  }
  .locked-channel {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
